<template>
  <v-col
    cols="12"
    sm="6"
    class="py-0"
  >
    <text-list-item
      :title="title"
      :text="text | currency"
      :css-style="cssStyle"
    />
    <span
      v-if="subtitle"
      class="text-xs mt-0"
    >
      {{ subtitle }}
    </span>
  </v-col>
</template>
<script>
import TextListItem from '@/components/controls/TextListItem.vue'

export default ({
  components: { TextListItem },
  props: {
    title: { type: String, required: true },
    text: { type: Number, required: true },
    subtitle: { type: String, default: null },
    cssStyle: { type: String, default: null },
  },
  setup() {
  },
})
</script>
